export default __webpack_public_path__ + "static/media/m_header_logo.5e2bfa30.svg";